import {PlaylistSlice} from "../slices/PlaylistSlice";

export const PlaylistAPI = {};

PlaylistAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/playlist`,
    method:   'POST',
    data:     data,
    slice:     PlaylistSlice.name,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

PlaylistAPI.revoke = (id, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/playlist/revoke`,
    method:   'POST',
    data:     {
      id
    },
    slice:     PlaylistSlice.name,
    action:    'revoke',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

PlaylistAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/profile/playlist`,
    method:    'DELETE',
    data:      {ids},
    slice:     PlaylistSlice.name,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

PlaylistAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/playlist`,
    method:   'PUT',
    data:     data,
    slice:     PlaylistSlice.name,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

PlaylistAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/profile/playlists`,
    method:    'GET',
    data:      data,
    slice:     PlaylistSlice.name,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

PlaylistAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/profile/playlist`,
    method:    'GET',
    data:      {id},
    slice:     PlaylistSlice.name,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

PlaylistAPI.format = (id, value, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/playlist/format`,
    method:   'POST',
    data: {
      id: id,
      stream_format_priority: value
    },
    slice:     PlaylistSlice.name,
    action:    'format',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

PlaylistAPI.quality = (id, value, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/playlist/quality`,
    method:   'POST',
    data: {
      id: id,
      stream_quality_priority: value,
    },
    slice:     PlaylistSlice.name,
    action:    'quality',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};
